<script lang="ts">
    import Navbar from "./Navbar.svelte";

    import Router from "svelte-spa-router";
    import {routes} from "../routes";
    import Notifications from "./Notifications.svelte";
</script>

<Notifications/>

<div class="wrapper">
    <Navbar/>
    <main class="overflow-auto">
        <Router {routes}/>
    </main>
</div>

<style global lang="postcss">
    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    .wrapper {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        min-width: 100%;
        width: max-content;
        @apply bg-gray-50
    }

    tr.striped:nth-child(odd) {
        @apply bg-gray-100
    }
    tr.selected, tr.striped.selected {
        @apply bg-yellow-300
    }

    .content-container {
        @apply p-5
    }

    .btn-primary {
        @apply focus:outline-none disabled:opacity-50 text-gray-700 bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:focus:ring-yellow-900;
    }

    .btn-secondary {
        @apply focus:outline-none disabled:opacity-50 text-gray-700 bg-gray-200 outline-gray-400 hover:bg-gray-300 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:focus:ring-gray-900;
    }

    .btn-icon {
        @apply text-gray-800 hover:text-gray-600 focus:outline-none rounded-md border border-gray-300 p-1;
    }

    .text-input {
        @apply bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5;
    }

    .custom-dropdown {
        @apply bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2;
    }
</style>
